import { Button, EpicIcons } from "@constellation-academy/epic-ui";
import React from "react";
import { graphql, useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type CreateClozeTextElementButton_CreateClozeTextElementMutation } from "@relay/CreateClozeTextElementButton_CreateClozeTextElementMutation.graphql";
import { useDraftStatusUpdater } from "../use-draft-status-updater";

const CREATE_CLOZE_TEXT_ELEMENT_MUTATION = graphql`
	mutation CreateClozeTextElementButton_CreateClozeTextElementMutation(
		$input: CreateClozeTextElementV2Input!
	) {
		Admin {
			ElearningV2 {
				createClozeTextElement(input: $input) {
					eLearningContentNode {
						...contentCard_TreeNodeFragment
					}
				}
			}
		}
	}
`;

type OwnProps = {
	eLearningContentNodeId: string;
};

export const CreateClozeTextElementButton = ({ eLearningContentNodeId }: OwnProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();
	const [CreateClozeTextElement, isCreatingClozeTextElement] =
		useMutation<CreateClozeTextElementButton_CreateClozeTextElementMutation>(
			CREATE_CLOZE_TEXT_ELEMENT_MUTATION,
		);
	return (
		<Button
			disabled={isCreatingClozeTextElement}
			tooltip={t("educationalOffer.createClozeTextTooltip")}
			icon={EpicIcons.WINDOW_MINIMIZE}
			onClick={() => {
				CreateClozeTextElement({
					variables: {
						input: {
							title: t("educationalOffer.newElement"),
							text: "",
							additionalWords: [],
							eLearningContentNodeId,
						},
					},
					updater: setDraft,
				});
			}}
		/>
	);
};
